import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Access Denied Component
 * Shown when user tries to access a route they don't have permission for
 */
export const AccessDenied = ({ requiredRole, userRole }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <svg
            className="mx-auto h-16 w-16 text-red-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Access Denied
        </h1>
        <p className="text-gray-600 mb-2">
          You don't have permission to access this page.
        </p>
        {requiredRole && userRole && (
          <p className="text-sm text-gray-500 mb-6">
            Required role: <span className="font-semibold">{requiredRole}</span>
            <br />
            Your role: <span className="font-semibold">{userRole}</span>
          </p>
        )}
        <div className="space-y-2">
          <Link
            to="/crm/counselor/login"
            className="inline-block w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
          >
            Return to Login
          </Link>
          <Link
            to="/"
            className="inline-block w-full text-gray-600 hover:text-gray-800 font-semibold py-2 px-6 rounded-lg transition-colors"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};
